import React, {useRef, useContext, useEffect, useState} from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import './AutoLogout.css'
import Logout from './Logout';
import UserContext from '../context/UserContext';

function AutoLogout(props) {

    const userCtx = useContext(UserContext)
    const [show, setShow] = useState(false)
    const [doLogout, setDoLogout] = useState(false)

    // 3 minutes  for testing - should be 15 minutes in production
    const MAX_INACTIVITY_MILLISECONDS = 15*60*1000
    const SHOW_WARNING_BEFORE_LOGOUT_SECS = 60

    // seconds before showing warning 
    const secondsLeft = useRef(999)
    const secondsLeftSpan = useRef()

    const wTimer = useRef()
    const lInterval = useRef()

    // timeoout till showing warning (milliseconds)
    const warningTimeout = MAX_INACTIVITY_MILLISECONDS - SHOW_WARNING_BEFORE_LOGOUT_SECS * 1000
    // timer to show warning dialog
    let warningTimer
    // interval for updating seconds count in the warning dialog
    let logoutInterval

    // when this timer runs out - show warning dialog
    const startWarningTimer = (timeout) => {
        warningTimer = setTimeout(showIdleWarning, timeout)
        wTimer.current = warningTimer
        document.addEventListener('mousemove', handleMouseMovement)
    }



    // show idle warning
    const showIdleWarning = () => {
        document.removeEventListener('mousemove', handleMouseMovement, false);
        setShow(true)
    }

    // close the warning Box and reset timers (user is active)
    const closeWarningDialog = () => {
        setShow(false)
        restartTimers()
    }

    // reset all timers
    const restartTimers = () => {
        // console.log(`restartTimers: warningTimer ${wTimer.current}`)
        if (wTimer.current !== undefined) {
            clearTimeout(wTimer.current);
        }

        // console.log(`restartTimers: logoutInterval ${lInterval.current}`)
        if (lInterval.current !== undefined) { 
            clearInterval(lInterval.current);
        }

        startWarningTimer(warningTimeout);
    }

    // mouse movement handler
    const handleMouseMovement = (e) => {
        restartTimers();
    }

    useEffect(() => {
        if (userCtx.isLoggedIn) {
            // console.log("******* Autologout Staring timers *******")
            startWarningTimer(warningTimeout)
        }
        

        return () => {

            // console.log("******* Autologout CLEAN UP *******")

            // cleanup function
            // console.log("Autologout warningTimer", wTimer.current)
            if (wTimer.current !== undefined) {
                // console.log("Autologout clear warningTimer")
                clearTimeout(wTimer.current);
            }

            // console.log("Autologout logoutInterval", lInterval.current)
            if (lInterval.current !== undefined) { 
                // console.log("Autologout clear logoutInterval")
                clearInterval(lInterval.current);
            }
            // remove mouse handler
            document.removeEventListener('mousemove', handleMouseMovement, false);
        }
    }, [userCtx.isLoggedIn])


    useEffect(() => {
        if (show) {
            // secondsLeft.current = (AUTO_LOGOUT_MINUTES - SHOW_WARNING_BEFORE_LOGOUT_MINUTES) * 60
            secondsLeft.current = 60
            secondsLeftSpan.current.textContent = `${Math.trunc(secondsLeft.current/60)} minute(s) ${secondsLeft.current%60} second(s)`
    
            // document.removeEventListener('mousemove', handleMouseMovement, false);
           
            // setup interval to trigger every second to update time left
            // by the end of 60 seconds period - logout
            logoutInterval = setInterval( () => {
                // console.log(`logout interval - ${secondsLeft.current} left`)
                if (secondsLeft.current > 0) {
                    secondsLeft.current -= 1;
                    secondsLeftSpan.current.textContent = `${Math.trunc(secondsLeft.current/60)} minute(s) ${secondsLeft.current%60} second(s)`
                } else {
                    // console.log("** warningTimer **", warningTimer)
                    if (wTimer.current !== undefined) {
                        // console.log("** Clear Timeout on warningTimer **", warningTimer)
                        clearTimeout(wTimer.current);
                    }
                    if (lInterval.current !== undefined) { 
                        clearInterval(lInterval.current);
                    }
    
                    setShow(false)
                    setDoLogout(true)
                }
                
            }, 1000)
    
            lInterval.current = logoutInterval
        }
        
    },[show])
    

    const logout = () => {
        setShow(false)
        setDoLogout(true)
        
    }

    const loggedOut = () => {
        setDoLogout(false)
        props.onLogout()
    }

    return (
        <>
            <Modal size="md" backdrop="static" centered show={show} backdropClassName='inactivityBackdrop' >
                <Modal.Header>
                    <Modal.Title><h1>Session Timeout Warning</h1></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="py-4 text-xl text-gray-600">Due to inactivity, your session will expire in: <span ref={secondsLeftSpan}>XXXXX</span></p>
                    {/* <p className="py-4 text-lg text-gray-600">Are you still here?</p> */}
                </Modal.Body>
                <Modal.Footer /*className='justify-content-between'*/>
                    <Button className='mx-2  fs-5 text' variant="secondary" onClick={logout}>
                        Logout
                    </Button>
                    <Button className='mx-2  fs-5 text' variant="primary" onClick={closeWarningDialog} autoFocus>
                        Keep me signed in
                    </Button>
                </Modal.Footer>
            </Modal>

            <Logout doLogout={doLogout} onLoggedOut={loggedOut} />

        </>
    )
}

export default AutoLogout
